import { Injectable } from "@angular/core";
import { SiriusServiceBase } from "@ibtech/sirius-angular-service";


@Injectable()
export class LandingLoginService extends SiriusServiceBase {
    constructor() {
        super();
    }

    

    
}
